/* Raishma desktop and mobile navigation controllers. */
(() => {

  function initMegaNav(scope) {
    var nav = scope.querySelector('[data-rs-mega-nav]');
    if (!nav || nav.dataset.megaReady) return;
    nav.dataset.megaReady = 'true';

    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-mega-item]'));
    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
    var closeTimer;
    var abort = new AbortController();
    var listen = function (target, event, handler) { target.addEventListener(event, handler, { signal: abort.signal }); };
    var cleanup = function () { clearTimeout(closeTimer); abort.abort(); };
    nav.cleanupMegaNav = cleanup;

    function setOpen(item, open) {
      var trigger = item.querySelector('[data-mega-trigger]');
      item.classList.toggle('is-open', open);
      item.querySelector('.rs-mega-nav__panel').inert = !open;
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeAll(except) {
      items.forEach(function (item) { if (item !== except) setOpen(item, false); });
    }

    listen(window.matchMedia('(max-width: 989px)'), 'change', function (event) { if (event.matches) closeAll(); });

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-mega-trigger]');
      setOpen(item, false);

      listen(trigger, 'click', function () {
        clearTimeout(closeTimer);
        var open = !item.classList.contains('is-open');
        closeAll(item);
        setOpen(item, open);
      });

      listen(item, 'mouseenter', function () {
        if (!hoverCapable.matches) return;
        clearTimeout(closeTimer);
        closeAll(item);
        setOpen(item, true);
      });

      listen(item, 'mouseleave', function () {
        if (!hoverCapable.matches) return;
        closeTimer = setTimeout(function () { setOpen(item, false); }, 120);
      });
    });

    listen(document, 'click', function (e) {
      if (!nav.contains(e.target)) closeAll();
    });

    listen(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = nav.querySelector('.is-open');
      if (!open) return;
      setOpen(open, false);
      var trigger = open.querySelector('[data-mega-trigger]');
      if (trigger) trigger.focus();
    });

    listen(nav, 'focusout', function (e) {
      if (!e.relatedTarget || !nav.contains(e.relatedTarget)) closeAll();
    });
  }
  initMegaNav(document);
  document.addEventListener('shopify:section:load', function (event) { initMegaNav(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var nav = event.target.querySelector('[data-rs-mega-nav]');
    if (nav && nav.cleanupMegaNav) nav.cleanupMegaNav();
  });

})();


(() => {
  const controllers = new Map();
  function init(scope = document) {
    scope.querySelectorAll('[data-rs-mobile-nav]').forEach(root => {
      if (controllers.has(root)) return;
      const abort = new AbortController();
      const listen = (target, event, handler) => target.addEventListener(event, handler, { signal: abort.signal });
      const toggle = root.querySelector('.rs-mobile-nav__toggle');
      const menu = root.querySelector('.rs-mobile-nav__menu');
      const close = menu.querySelector('.rs-mobile-nav__close');
      let open = false, timer, scrollY = 0, savedStyle = null;
      function unlock() {
        if (!savedStyle) return;
        Object.assign(document.body.style, savedStyle);
        savedStyle = null;
        document.documentElement.classList.remove('rs-mobile-nav-open');
        const previous = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, scrollY);
        document.documentElement.style.scrollBehavior = previous;
      }
      function setOpen(next, focus = true) {
        clearTimeout(timer);
        open = next;
        if (next && !savedStyle) {
          scrollY = window.scrollY;
          savedStyle = Object.fromEntries(['position', 'top', 'width', 'overflow'].map(key => [key, document.body.style[key]]));
          Object.assign(document.body.style, { position: 'fixed', top: `-${scrollY}px`, width: '100%', overflow: 'hidden' });
          document.documentElement.classList.add('rs-mobile-nav-open');
        }
        menu.inert = !next;
        menu.classList.toggle('is-open', next);
        toggle.classList.toggle('open', next);
        toggle.setAttribute('aria-expanded', String(next));
        if (next) close.focus({ preventScroll: true });
        else {
          if (focus) toggle.focus({ preventScroll: true });
          timer = setTimeout(unlock, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 420);
        }
      }
      listen(toggle, 'click', () => setOpen(!open));
      listen(close, 'click', () => setOpen(false));
      listen(menu, 'click', event => { if (event.target.closest('a[href]')) setOpen(false, false); });
      listen(document, 'keydown', event => {
        if (!open) return;
        if (event.key === 'Escape') { event.preventDefault(); setOpen(false); }
        if (event.key !== 'Tab') return;
        const elements = [...menu.querySelectorAll('a[href], button, summary, [tabindex="0"]')].filter(el => el.getClientRects().length);
        const first = elements[0], last = elements[elements.length - 1];
        if (event.shiftKey && (document.activeElement === first || !menu.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !menu.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
      });
      const groups = root.querySelectorAll('[data-mobile-group]');
      groups.forEach(group => listen(group, 'toggle', () => {
        if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
      }));
      listen(matchMedia('(min-width: 990px)'), 'change', event => { if (event.matches) { setOpen(false, false); clearTimeout(timer); unlock(); } });
      controllers.set(root, () => { clearTimeout(timer); unlock(); abort.abort(); });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((cleanup, root) => { if (event.target.contains(root)) { cleanup(); controllers.delete(root); } });
  });
})();
